import {
    EEntities,
    EMessagesAuthErrorResponseTypes,
    TMessages,
} from 'types/messages';

const messages: TMessages = {
    [EEntities.admins]: {
        add: {
            onSuccess: () => 'Admin user successfully added',
            onError: (e) => `Can't add admin user, error: ${e}`,
        },
        del: {
            onSuccess: () => 'Admin user successfully deleted',
            onError: (e) => `Can't delete admin user, error: ${e}`,
        },
    },
    [EEntities.users]: {
        onEkycConfirm: {
            onSuccess: () => 'eKYC successfully confirmed',
            onError: (e) => `Can't confirm eKYC, error: ${e}`,
        },
        onEkycReject: {
            onSuccess: () => 'eKYC successfully rejected',
            onError: (e) => `Can't reject eKYC, error: ${e}`,
        },
        onPinReset: {
            onSuccess: () => "User's PIN successfully reset",
            onError: (e) => `Can't reset user's PIN, error: ${e}`,
        },
        onUnblock: {
            onSuccess: () => "User's successfully unblocked",
            onError: (e) => `Can't unblock user, error: ${e}`,
        },
    },
    [EEntities.auth]: {
        onSignIn: {
            onSuccess: () => 'Welcome!',
            onErrorSwitch: () => ``,
            onAnyOtherError: (e) => `Error: ${e}`,
            onWrongCredentials: () => 'Wrong email or password',
        },
    },
    [EEntities.app]: {
        onAnyOtherError: () =>
            'Network connection error. Please try again later',
        onNetworkError: () =>
            'Network connection error. Please try again later',
    },
    [EEntities.pendingTasks]: {
        onCreatePendingTask: {
            onSuccess: (actionType?: string) =>
                `Requested action ${actionType} has been successfully added to Pending Task. Please contact your Approver.`,
        },
    },
};

messages.auth.onSignIn.onErrorSwitch = (e) => {
    switch (e) {
        case EMessagesAuthErrorResponseTypes.unauthorized:
            return messages.auth.onSignIn.onWrongCredentials();
        default:
            return messages.auth.onSignIn.onAnyOtherError(e);
    }
};

export default messages;
